
const veriflengthText = (text, minLength = 10, champ,) => {
  if (text.length < minLength) {
    return false;
  }
  return true;
};

export const validateField = ({
  e,
  minLength,
  label,
  setErrors,
  handleUpdateChange,
}) => {
  const { name, value } = e.target;

  const isValid = veriflengthText(value, minLength, label);

  setErrors((prev) => ({
    ...prev,
    [name]: !isValid,
  }));

  if (isValid) {
    handleUpdateChange(e);
  }

  return isValid;
};

export const isButtonDisabled = (errors) => {
  return Object.values(errors).some((err) => err === true);
};